import { Fluxo } from "./main";
import { ReactFlowProvider } from "reactflow";
import { useState } from "react";

const ReactFlowWidget = () => {
    const [instance, setInstance] = useState<any>(null);
    const [focusOnNode, setFocusOnNode] = useState<((id: string) => void) | null>(null);

    return (
        <ReactFlowProvider>
            <Fluxo
                nodes={[]}
                edges={[]}
                setInstance={setInstance}
                setFocusOnNode={setFocusOnNode}
            />
        </ReactFlowProvider>
    );
};

export default ReactFlowWidget;